export default {
  state: {
    open: false,
    photos: [
      'https://images.unsplash.com/photo-1607446926419-b0030ed4731b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1567&q=80',
    ],
    active: 0,
  },
  mutations: {
    setPhotosState(state, value) {
      state.open = value;
    },
    setPhotos(state, photos) {
      state.photos = photos;
    },
    setActive(state, active) {
      state.active = active;
    },
    nextPhoto(state) {
      state.active = state.active < state.photos.length - 1 ? state.active + 1 : state.active;
    },
    prevPhoto(state) {
      state.active = state.active > 0 ? state.active - 1 : state.active;
    },
  },
  actions: {
    setPhotosState({ commit }, value) {
      commit('setPhotosState', value);
    },
    setPhotos({ commit }, data) {
      commit('setPhotos', data.photos);
      commit('setActive', data.active);
    },
    setActivePhoto({ commit }, active) {
      commit('setActive', active);
    },
    nextPhoto({ commit }) {
      commit('nextPhoto');
    },
    prevPhoto({ commit }) {
      commit('prevPhoto');
    },
  },
  getters: {
    getPhoto: (s) => s.photos[s.active],
    getPhotoIndex: (s) => s.active,
    getPhotoItems: (s) => s.photos,
    getPhotos: (s) => s.open,
  },
};
